import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  MenuItem,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import TextfieldDefault from "../../../../components/textField/TextfieldDefaultNew";
import { CustomTheme } from "../../../../types/customTheme";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { createLicense } from "../../../../services/locationApp/licenseService";
import Cookies from "js-cookie";

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    dialogPaper: {
      borderRadius: 10,
    },
    dropdown: {
      backgroundColor: theme.palette.background.entity_background,
      borderRadius: 10,
      "& .MuiOutlinedInput-root": {
        borderRadius: 10,
        backgroundColor: theme.palette.background.entity_background,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
    dropdownMenuPaper: {
      backgroundColor: theme.palette.background.entity_background,
      borderRadius: 10,
      boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
      padding: theme.spacing(1),
    },
    errorText: {
      color: "#FF0000",
      fontSize: 12,
      marginTop: -8,
      marginBottom: 4,
    },
    radioRoot: {
      color: theme.palette.text.secondary + " !important",
    },
    statusPill: {
      borderRadius: 8,
      padding: "2px 8px",
      fontSize: "12px",
      textAlign: "center",
      fontWeight: 600,
      minWidth: 70,
      display: "inline-block",
      width: "fit-content",
    },
  }),
);

interface Props {
  open: boolean;
  onClose: () => void;
  locationId: string;
  onUpdate: () => void;
}
const generateDeviceId = (): string => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let id = "DEV-";
  for (let i = 0; i < 8; i++) {
    id += chars[Math.floor(Math.random() * chars.length)];
  }
  return "DEV-" + Date.now().toString(36).toUpperCase();
};

const LicenseCreateModal: React.FC<Props> = ({
  open,
  onClose,
  locationId,
  onUpdate,
}) => {
  const classes = useStyles();
  // const theme = useTheme<CustomTheme>();

  const [name, setName] = useState("");
  const [amount, setAmount] = useState("0.00");
  const [amountError, setAmountError] = useState("");
  const [period, setPeriod] = useState("monthly");
  const [status, setStatus] = useState("active");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [deviceId, setDeviceId] = useState("");
  const [licenseCode, setLicenseCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isFormValid = (): boolean => {
    return (
      name.trim() !== "" &&
      // subscriptionId.trim() !== "" &&
      deviceType.trim() !== "" &&
      amount.trim() !== ""
    );
  };

  useEffect(() => {
    if (open) {
      setLicenseCode(""); // clear (backend will generate)
      setName("");
      setAmount("");
      setPeriod("monthly");
      setStatus("active");
      setSubscriptionId("");
      setDeviceType("");
      // setDeviceId("");
      setDeviceId("");
      setAmountError("");
    }
  }, [open]);

  const validateAmount = (val: string): boolean => {
    const decimalRegex = /^\d+\.\d{2}$/;
    return decimalRegex.test(val) && parseFloat(val) >= 0;
  };

  const getToken = () => Cookies.get("idToken") || null;

  const handleSave = async () => {
  // Validate that the subscription amount is a valid number
  if (!amount || isNaN(Number(amount)) || Number(amount) < 0) {
    setAmountError("Please enter a valid positive amount.");
    return;
  }

  setIsLoading(true);
  try {
    const token = await getToken();
    // Automatically format amount to two decimal places
    const formattedAmount = parseFloat(amount).toFixed(2);

    // Create license
    await createLicense(
      locationId,
      {
        name: name.trim(),
        subscriptionAmount: formattedAmount,  // Ensure it's saved as a number with 2 decimals
        subscriptionPeriod: period,
        status,
        subscriptionId: subscriptionId.trim(),
        deviceType,
        deviceId,
      },
      token
    );

    onUpdate();  // Reload the licenses list
    onClose();   // Close the modal
  } catch (err) {
    console.error("POST create license error →", err);
  } finally {
    setIsLoading(false);
  }
};


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle>Create New License</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          {/* Use TextField for readonly */}
   
          <TextfieldDefault
            id="license-name"
            name="license-name"
            type="text"
            label="Name"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setName(e.target.value)
            }
            style={{ width: "100%" }}
          />

          <TextfieldDefault
            id="subscription-id"
            name="subscription-id"
            type="text"
            label="Subscription ID"
            value={subscriptionId}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSubscriptionId(e.target.value)
            }
            style={{ width: "100%" }}
          />

          {/* <TextfieldDefault
            id="subscription-amount"
            name="subscription-amount"
            type="number"
            label="Subscription Amount"
            value={amount}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setAmount(e.target.value)
            }
            style={{ width: "100%" }}
          /> */}

<TextfieldDefault
  id="subscription-amount"
  name="subscription-amount"
  type="number"
  label="Subscription Amount"
  value={amount}
  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
    // Allow only numeric input
    let value = e.target.value;

    // Prevent non-numeric values
    if (/^\d+(\.\d{0,2})?$/.test(value)) {
      // Automatically format the value to 2 decimal places
      setAmount(value);
    }
  }}
  style={{ width: "100%" }}
/>



          {amountError && (
            <Typography className={classes.errorText}>{amountError}</Typography>
          )}

          <Box>
            <Box>
              <FormControl component="fieldset">
                <FormLabel style={{ color: "#FFFFFF" }}>
                  Subscription Period
                </FormLabel>
                <RadioGroup
                  row
                  value={period}
                  onChange={(e) => setPeriod(e.target.value)}
                >
                  {["monthly", "weekly", "annually", "one-off"].map((opt) => (
                    <FormControlLabel
                      key={opt}
                      value={opt}
                      control={<Radio classes={{ root: classes.radioRoot }} />}
                      label={opt.charAt(0).toUpperCase() + opt.slice(1)}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>

          <TextField
            select
            label="Status"
            variant="outlined"
            fullWidth
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className={classes.dropdown}
            SelectProps={{
              MenuProps: { classes: { paper: classes.dropdownMenuPaper } },
            }}
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="trial">Trial</MenuItem>
          </TextField>

          <TextField
            select
            label="Device Type"
            variant="outlined"
            fullWidth
            value={deviceType}
            onChange={(e) => setDeviceType(e.target.value)}
            className={classes.dropdown}
            SelectProps={{
              MenuProps: { classes: { paper: classes.dropdownMenuPaper } },
            }}
          >
            {[
              "POS Terminal",
              "Handheld Terminal",
              "Fullsize Kiosk",
              "Tablet Kiosk",
              "KDS",
              "Printer Server",
              "Online Ordering",
              "Table Booking",
              "Inventory",
              "Clock-In",
              "Loyalty",
              "Next-Drop",
            ].map((opt) => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </TextField>

        
        </Box>
      </DialogContent>
      <DialogActions>
        <ButtonCommon
          variant="contained"
          color="orange"
          onClick={onClose}
          style={{ minWidth: 120, height: 36 }}
        >
          Cancel
        </ButtonCommon>
        <ButtonCommon
          variant="contained"
          color="green"
          onClick={handleSave}
          isLoadingPage={isLoading}
          disabled={!isFormValid()}
          style={{ minWidth: 120, height: 36 }}
        >
          Save
        </ButtonCommon>
      </DialogActions>
    </Dialog>
  );
};

export default LicenseCreateModal;
